import React from 'react';
import { Text, Spacer } from '@myinterview/component-library';
import { useTranslation } from 'react-i18next';

export const TopTips:React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="myinterview-widget-top-tips myinterview-widget--rtl-support">
      <Text className="myinterview-widget-top-tips__title" size="L-Regular">{t('top_tips.title')}</Text>
      <Spacer y={1} />
      <ul className="myinterview-widget-top-tips__tips">
        {[...new Array(6)].map((_, idx) => <li key={`${`${idx}`}`}><Text size="S-Regular">{t(`top_tips.tip_${idx + 1}`)}</Text></li>)}
      </ul>
      <div>{t('top_tips.tip_7')}</div>
      <Spacer y={1} />
    </div>
  );
};
